import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Snackbar } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import { configurarHandlersAuthApi } from '../../services/api';
import { possuiSessaoSalva } from '../../services/authStorage';
import { registrarErro } from '../../services/registro'
import { avisoDeAcessoNegado, avisoDeSaida } from '../../services/avisoSessao'

/**
 * Boot da sessão: GET /me se houver sessão salva (confirma o cookie httpOnly e recupera o CSRF).
 * Liga handlers 401 → logout+/login e 403 → aviso (sem logout).
 * P-Q8: a saída para o login e o 403 sempre dizem o motivo (sessão expirada, sem conexão, perfil bloqueado,
 * sessão renovada, senha a definir, sem permissão).
 */
const AuthBoot = () => {
  const { carregarMe, logout, atualizarAcesso } = useAuth();
  const navigate = useNavigate();
  const [aviso, setAviso] = useState('');

  useEffect(() => {
    configurarHandlersAuthApi({
      onUnauthorized: (erro) => {
        logout();
        navigate('/login', { replace: true, state: { aviso: avisoDeSaida(erro) } });
      },
      onForbidden: (erro) => {
        // O0c: permissão/senha/CSRF podem ter mudado com a pessoa logada → relê o /me (menu e botões se ajustam)
        const codigo = erro?.response?.data?.codigo;
        // Login e troca de senha mostram a própria recusa no formulário: sem aviso duplicado
        if (/\/api\/auth\/(login|trocar-senha)/.test(String(erro?.config?.url || '')) || codigo === 'PERFIL_BLOQUEADO') return;
        if (['SEM_PERMISSAO', 'CSRF_INVALIDO', 'TROCA_SENHA_OBRIGATORIA'].includes(codigo)) atualizarAcesso({ forcar: true });
        setAviso(avisoDeAcessoNegado(erro));
        registrarErro('Acesso negado (403): escopo empresa/filial/usuário.')
      },
    });
  }, [logout, navigate, atualizarAcesso]);

  useEffect(() => {
    if (!possuiSessaoSalva()) return undefined;
    let cancelado = false;
    carregarMe().catch((erro) => {
      if (!cancelado) {
        navigate('/login', { replace: true, state: { aviso: avisoDeSaida(erro) } });
      }
    });
    return () => {
      cancelado = true;
    };
    // Apenas no mount: depois disso o login/troca de contexto já trazem a sessão
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Snackbar
      open={Boolean(aviso)}
      autoHideDuration={8000}
      onClose={(_, motivo) => motivo !== 'clickaway' && setAviso('')}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert severity="warning" variant="filled" onClose={() => setAviso('')} data-testid="aviso-acesso-negado" sx={{ width: '100%' }}>
        {aviso}
      </Alert>
    </Snackbar>
  );
};

export default AuthBoot;
